import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../../Common/DataTable/DataTable";
import {
  GET_ALL_BOOKING_LOGS_REQUEST,
  GET_ALL_RESERVATION_LIST_REQUEST,
  PUT_ROOM_REASSIGN_REQUEST,
} from "../../../../../Utils/Constant";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";

import { bookingLogsColumns } from "../BookingLogsColumns";

const BookingLogsTable = ({ reservation_id }) => {
  const dispatch = useDispatch();

  const [bookingData, setBookingData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);

  const { loading, reassign, bookingLogs } = useSelector(
    (state) => state.roomReservationList
  );

  useEffect(() => {
    dispatch({
      type: GET_ALL_BOOKING_LOGS_REQUEST,
      payload: { page, limit: pageSize, sortBy, sortOrder, reservation_id },
    });
  }, [dispatch, page, pageSize, sortBy, sortOrder, reassign, reservation_id]);

  useEffect(() => {
    if (bookingLogs?.data?.data?.length) {
      const extractedData = bookingLogs?.data?.data?.map((log) => ({
        first_name: log.staff?.first_name || "N/A", // Ideally you'd map the UUID to an actual name
        email: log?.staff?.email || "N/A", // Dummy placeholder, replace if you have actual email
        phone: log?.staff?.phone || "N/A", // Dummy placeholder, replace if you have actual email
        action: log.action || "N/A",
        remarks: log.remarks || "N/A",
        time: new Date().toLocaleString(), // Dummy current time; replace with log.time if available
      }));

      setBookingData(extractedData);
    } else {
      setBookingData([]);
    }
  }, [openMenuId, bookingLogs]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Extract total entries and total pages from API pagination info
  const totalEntries = bookingLogs?.data?.pagination?.totalResults || 0;
  const totalPages = bookingLogs?.data?.pagination?.totalPages || 1;

  return (
    <div>
      <DataTable
        columns={bookingLogsColumns}
        data={bookingData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
    </div>
  );
};

export default BookingLogsTable;
